import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Components 

import Action from '../../actions/Action';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import GridViewIcon from '@mui/icons-material/GridView';
import WrapTextOutlinedIcon from '@mui/icons-material/WrapTextOutlined';

const HeaderActions: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation();

    const colors = useAppSelector(state => state.theme.colors); 
    const section = useAppSelector(state => state.savedConsultation.section); 
    const consultationId = useAppSelector(state => state.savedConsultation.consultationId); 
    const folderView = useAppSelector((state) => state.fileExplorer.folderView); 

    const trashFiles = useAppSelector((state) => state.trash.trashFiles); 

    const [isBackNavigationDisabled, setIsBackNavigationDisabled] = useState(false); // Keep this, might be used for 'leaveTrash'
    const [isForwardNavigationDisabled, setIsForwardNavigationDisabled] = useState(true); // Trash has no forward nav
    const [isRefreshDisabled, setIsRefreshDisabled] = useState(false); // Refresh should usually be enabled

    // -- 

    // Trash doesn't depend on consultation section for navigation/refresh logic
    // Remove useEffect related to consultation section

    // -- 

    // --

    return (

        <Box style={{ 
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center', 
            width: '100%',
            height: '70%', 
            fontSize: 20,
            overflowX: 'auto', // Allow horizontal scrolling on small screens
            overflowY: 'hidden',
            flexWrap: 'nowrap', // Prevent wrapping
            paddingLeft: 1, // Add some padding
        }}>

            <Action title={'goBack'} iconColor={colors?.main} action={'leaveTrash'} type='default' disabled={isBackNavigationDisabled} hideLabel>
                <ArrowBackIcon /> 
            </Action>
            
            <Action title={'refresh'} iconColor={colors?.main} action={'refreshTrash'} type='default' disabled={isRefreshDisabled}>
                <RefreshIcon /> 
            </Action>

            <Action title={'changeView'} iconColor={colors?.main} action={'changeFolderView'} type='default'>
                { folderView === 'row' ? <WrapTextOutlinedIcon /> : <GridViewIcon />}
            </Action>

            { (trashFiles && trashFiles?.length > 0) && <Action title={'emptyBin'} iconColor={colors?.main} action={'emptyTrash'} type='default'>
                <Box component="img" sx={{ width: 20 }} src={require('../../../../../../assets/icons/files/empty-bin.png')} />
            </Action>}

        </Box>

    );

};

export default HeaderActions;